export const restoreBodyScroll = () => {
  if (typeof window === 'undefined' || !window.document?.body) {
    return;
  }

  const { body } = window.document;
  body.style.overflow = '';
  body.style.paddingRight = '';
  delete body.dataset.scrollLocked;
  delete body.dataset.retainedOverflow;
  body.classList.remove('slideout-expanded');
};
